import { style } from 'typestyle'
export const pr8 = style({ paddingRight: '8px' })
